import styled from 'styled-components'
import { themeGet } from 'styled-system'

export const DefaultSiteSelectorWrapper = styled.div`
  box-sizing: border-box;
  display: flex;
  justify-content: flex-end;
  padding: 1.25rem 1.25rem 0 0;
  align-items: center;
  width: 100%;
  z-index: 99999;
  margin: auto;
  max-width: ${themeGet('breakpoints.sizes.large')};

  ${themeGet('breakpoints.mobileLarge')} {
    padding-right: 1rem;
  }
`

export const SiteSelectorK8WrapperLight = styled(DefaultSiteSelectorWrapper)`
  padding: 1.25rem 1.25rem 1.25rem 0;
  z-index: 99999 ${themeGet('breakpoints.mobileLarge')} {
    padding-right: 1rem;
  }

  div {
    color: ${themeGet('colors.white')}
    border-bottom: 1px solid transparent;
    border-top: 1px solid transparent;

    transition: color 0.2s ease, border-bottom 0.2s ease;
    &:hover {
      border-bottom: 1px solid ${themeGet('colors.white')};
      border-radius: 0;
      color: ${themeGet('colors.white')};
    }

    &:focus {
     border-bottom: 1px solid ${themeGet('colors.white')};
      border-radius: 0;
      color: ${themeGet('colors.white')};
    }
  }
`

export const SiteSelectorK8WrapperDark = styled(SiteSelectorK8WrapperLight)`
  div {
    color: ${themeGet('colors.buttons.primary.bgActive')};
    border-bottom: 1px solid transparent;

    &:hover {
      border-bottom: 1px solid transparent;
      color: ${themeGet('colors.buttons.primary.bgHover')};
    }

    &:focus {
      border-bottom: 1px solid transparent;
      color: ${themeGet('colors.buttons.primary.bgHover')};
    }
  }
`
